module.exports = __webpack_public_path__ + "static/media/Jermaine.8d95dde0.jpg";